import { seoConfig } from '@config/seo';

export type BreadcrumbItem = {
  name: string;
  path: string;
};

export const normalizePathname = (value?: string) => {
  if (!value) return '/';

  let candidate = value;

  try {
    const url = new URL(value);
    candidate = url.pathname;
  } catch {
    // treat value as relative path
  }

  candidate = candidate.replace(/\\/g, '/');
  const [path] = candidate.split('?');
  const [cleanPath] = path.split('#');

  let normalized = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
  normalized = normalized.toLowerCase();

  if (normalized !== '/' && normalized.endsWith('/')) {
    normalized = normalized.replace(/\/+$/g, '');
  }

  return normalized === '' ? '/' : normalized;
};

export const buildCanonicalUrl = (pathOrUrl?: string) => {
  if (!pathOrUrl) {
    return `${seoConfig.siteUrl}/`;
  }

  if (/^https?:\/\//i.test(pathOrUrl)) {
    try {
      const url = new URL(pathOrUrl);
      return `${url.origin}${normalizePathname(url.pathname)}`;
    } catch {
      return pathOrUrl;
    }
  }

  const pathname = normalizePathname(pathOrUrl);
  return pathname === '/' ? `${seoConfig.siteUrl}/` : `${seoConfig.siteUrl}${pathname}`;
};

export const ensureAbsoluteUrl = (value?: string) => {
  if (!value) return value;

  if (/^https?:\/\//i.test(value)) {
    try {
      const url = new URL(value);
      return `${url.origin}${normalizePathname(url.pathname)}`;
    } catch {
      return value;
    }
  }

  const pathname = normalizePathname(value);
  return pathname === '/' ? `${seoConfig.siteUrl}/` : `${seoConfig.siteUrl}${pathname}`;
};

export const createBreadcrumbList = (items: BreadcrumbItem[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: buildCanonicalUrl(item.path),
  })),
});
